import { getStore } from '../store/store';
import { mutatorAction } from 'satcheljs';

/*
 * Toggles isDraggedOver state
 * @param isDraggedOver indicates if folder pane is dragged over
 */
const setIsDraggedOverStateMutator: (isDraggedOver: boolean) => void = mutatorAction(
    'setIsDraggedOverState',
    function setIsDraggedOverState(isDraggedOver: boolean): void {
        getStore().isDraggedOver = isDraggedOver;
    }
);
export default setIsDraggedOverStateMutator;
